import { TypographyOptions } from "@mui/material/styles/createTypography";

const typography: TypographyOptions = {
  fontFamily: "'Inter Tight', sans-serif",
  h1: {
    fontWeight: 700,
    fontSize: "48px",
    [`@media (max-width:900px)`]: { fontSize: "36px" },
    [`@media (max-width:600px)`]: { fontSize: "28px" },
  },
  h2: {
    fontWeight: 700,
    fontSize: "16px",
    [`@media (max-width:900px)`]: { fontSize: "14px" },
    [`@media (max-width:600px)`]: { fontSize: "12px" },
  },
  h3: {
    fontWeight: 700,
    fontSize: "36px",
    [`@media (max-width:900px)`]: { fontSize: "28px" },
    [`@media (max-width:600px)`]: { fontSize: "24px" },
  },
  h4: {
    fontWeight: 600,
    fontSize: "32px",
    [`@media (max-width:900px)`]: { fontSize: "26px" },
    [`@media (max-width:600px)`]: { fontSize: "22px" },
  },
  h5: {
    fontWeight: 600,
    fontSize: "28px",
    [`@media (max-width:900px)`]: { fontSize: "24px" },
    [`@media (max-width:600px)`]: { fontSize: "20px" },
  },
  h6: {
    fontWeight: 600,
    fontSize: "24px",
    [`@media (max-width:900px)`]: { fontSize: "20px" },
    [`@media (max-width:600px)`]: { fontSize: "18px" },
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: "20px",
    [`@media (max-width:900px)`]: { fontSize: "18px" },
    [`@media (max-width:600px)`]: { fontSize: "16px" },
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: "18px",
    [`@media (max-width:900px)`]: { fontSize: "16px" },
    [`@media (max-width:600px)`]: { fontSize: "14px" },
  },
  body1: {
    fontWeight: 600,
    fontSize: "18px",
    [`@media (max-width:900px)`]: { fontSize: "16px" },
    [`@media (max-width:600px)`]: { fontSize: "14px" },
  },
  body2: {
    fontWeight: 700,
    fontSize: "14px",
    [`@media (max-width:900px)`]: { fontSize: "12px" },
    [`@media (max-width:600px)`]: { fontSize: "10px" },
  },
  caption: {
    fontWeight: 400,
    fontSize: "12px",
    [`@media (max-width:900px)`]: { fontSize: "10px" },
    [`@media (max-width:600px)`]: { fontSize: "8px" },
  },
  overline: {
    fontWeight: 500,
    color: "inherit",
    lineHeight: "18px",
    fontSize: '14px',
    textTransform: 'none',
    [`@media (max-width:900px)`]: { fontSize: "12px" },
    [`@media (max-width:600px)`]: { fontSize: "10px" },
  },
  button: {
    fontWeight: 600,
    fontSize: "16px",
    textTransform: "none",
    [`@media (max-width:900px)`]: { fontSize: "14px" },
    [`@media (max-width:600px)`]: { fontSize: "12px" },
  },
};

export default typography;
